<!--
 * @Author: your name
 * @Date: 2020-04-23 17:57:27
 * @LastEditTime: 2021-05-25 14:14:12
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\views\ProductCenter\index.vue
-->
<template>
  <div class="page-productCenter">
    <Header  path='/productCenter'></Header>
    <div class="productCenter-banner"></div>
    <div class="productCenter-describe">
      <div class="describe-item describe-item-1" @click="jump('/nBDetails')"></div>
      <div class="describe-item describe-item-2" @click="jump('/iOTDetails')"></div>
      <div class="describe-item describe-item-3" @click="jump('/productDetails')"></div>
      <div class="describe-part">
        <div class="part-item ui-flex ui-flex-justify-center">
          <div class="part-item-child part-item-1">
            <div class="part-item-btn" @click="jump('/try')"></div>
          </div>
          <div class="part-item-child part-item-2">
            <div class="part-item-btn" @click="open"></div>
          </div>
        </div>
        
        <div class="part-item ui-flex ui-flex-justify-center">
          <div class="part-item-child part-item-3">
            <div class="part-item-btn" @click="open"></div>
          </div>
          <div class="part-item-child part-item-4">
            <div class="part-item-btn" @click="open"></div>
          </div>
        </div>
      </div>
    </div>
    
    <Footer></Footer>
  </div>

</template>
<script>
    import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  import { MessageBox as MessageBoxPC } from 'element-ui';
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {

        columns:[
          {id:0,title:'2020',children:[
            {id:0,month:'1月',explain:'公司取得“ISO三体系认证证书。”'},
          ]},
          {id:1,title:'2019',children:[
            {id:0,month:'12月',explain:'“渝神缘物联网膜式燃气表”正式取得，型式批准证书。'},
            {id:1,month:'11月',explain:'公司获得重庆市“高新企业证书”'},
            {id:2,month:'6月',explain:'“渝神缘智能燃气管理平台2.0“正式上线'},
            {id:3,month:'5月',explain:'公司取得“防爆合格证”'},
            {id:4,month:'1月',explain:'渝神缘物联网膜式燃气表销量突破十万支'},
          ]},
          {id:2,title:'2018',children:[
            {id:0,month:'12月',explain:'公司取得“实用新型证书”'},
            {id:1,month:'1月',explain:'“渝神缘物联网膜式燃气表销量突破3万支'},

          ]},
          {id:3,title:'2017',children:[
            {id:0,month:'12月',explain:'第一台物联网表研发成功'},
            {id:1,month:'1月',explain:'“渝神缘智能燃气管理平台1.0”正式上线'},

          ]},
        ]
      }
    },
    methods:{
      /**
       * 点击跳转
      */
      jump (value) {
        console.log('value========',value)
        router.push({
            path: value,
          }).catch(err => {
            console.log(err)
          })
        
      },
      open() {
        MessageBoxPC.alert('023-68663505', '电话咨询', {
          confirmButtonText: '确定',
          
        }).catch((err)=>{
          console.log(err);
        });
      }
    }
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>